// extracted by mini-css-extract-plugin
module.exports = {"vGray16":"#9ea6b3","modalHeader":"Community_modalHeader__1d_vG","modalTitle":"Community_modalTitle__y3zZr","modalBody":"Community_modalBody__6lEGD"};